import { render } from "./STFMFM02C21CopyMoveModal.vue?vue&type=template&id=ffac394e"
import script from "./STFMFM02C21CopyMoveModal.vue?vue&type=script&lang=js"
export * from "./STFMFM02C21CopyMoveModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TDS\\40_製造(M)\\99_電帳法_USE\\Tatsuzin_filemanage\\vue\\tdsvue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__